// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_PARTNER = '/partner';
const ROOTS_ADMIN = '/admin';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: '/',
  register:  '/register',
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, 'reset-password'),
  newPassword: '/new-password',
  successPassword: '/success-password',
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  broadcasts: {
    root: path(ROOTS_DASHBOARD, '/broadcasts'),
  },
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  fileManager: path(ROOTS_DASHBOARD, '/files-manager'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    home: path(ROOTS_DASHBOARD, '/home'),
    chats: path(ROOTS_DASHBOARD, '/chats'),
    admins: path(ROOTS_DASHBOARD, '/admins'),
    users: path(ROOTS_DASHBOARD, '/users'),
    invoicing: path(ROOTS_DASHBOARD, '/invoicing'),
    file: path(ROOTS_DASHBOARD, '/file'),
    schedule: path(ROOTS_DASHBOARD, '/schedule'),
    knowledgeBase: path(ROOTS_DASHBOARD, '/knowledge-base'),
    instance: path(ROOTS_DASHBOARD, '/instance'),
    contacts: path(ROOTS_DASHBOARD, '/contacts'),
    assistantConfig: path(ROOTS_DASHBOARD, '/alfred-studio'),
    // pdv: path(ROOTS_DASHBOARD, '/pdv')
  },
  users: {
    list: path(ROOTS_DASHBOARD, '/users'),
    new: path(ROOTS_DASHBOARD, '/users/new'),
    details: (id: string) => path(ROOTS_DASHBOARD, `/users/${id}`),
  },
  delivery: {
    root: path(ROOTS_DASHBOARD, '/delivery'),
    orders: path(ROOTS_DASHBOARD, '/delivery/orders'),
    dashboard: path(ROOTS_DASHBOARD, '/delivery/dashboard'),
  },
  campaign: {
    root: path(ROOTS_DASHBOARD, '/broadcasts/campaign'),
    list: path(ROOTS_DASHBOARD, '/broadcasts/campaign'),
    new: path(ROOTS_DASHBOARD, '/broadcasts/campaign/new'),
    details: (id: string) => path(ROOTS_DASHBOARD, `/broadcasts/campaign/${id}`),
  },
  followUp: {
    root: path(ROOTS_DASHBOARD, '/broadcasts/followup'),
    list: path(ROOTS_DASHBOARD, '/broadcasts/followup'),
    new: path(ROOTS_DASHBOARD, '/broadcasts/followup/new'),
    details: (id: string) =>
      path(ROOTS_DASHBOARD, `/broadcasts/followup/${id}`),
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    plan: path(ROOTS_DASHBOARD, '/user/plan'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    integrations: path(ROOTS_DASHBOARD, '/user/integrations'),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    list: path(ROOTS_DASHBOARD, '/invoice/list'),
    new: path(ROOTS_DASHBOARD, '/invoice/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
    demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  },
  wallet: {
    root: path(ROOTS_DASHBOARD, '/wallet'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (title: string) => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_PARTNER = {
  root: ROOTS_PARTNER,
  login: path(ROOTS_PARTNER, '/login'),
  home: path(ROOTS_PARTNER, '/home'),
  clients: path(ROOTS_PARTNER, '/clients'),
  signatures: path(ROOTS_PARTNER, '/signatures'),
};

export const PATH_ADMIN = {
  root: ROOTS_ADMIN,
  login: path(ROOTS_ADMIN, '/login'),
  dashboard: path(ROOTS_ADMIN, '/dashboard'),
  clients: path(ROOTS_ADMIN, '/clients'),
  clientDetail: (id: string) => path(ROOTS_ADMIN, `/clients/${id}`),
  finance: path(ROOTS_ADMIN, '/financeiro'),
  usage: path(ROOTS_ADMIN, '/uso'),
  partners: path(ROOTS_ADMIN, '/parceiros'),
  plans: path(ROOTS_ADMIN, '/planos'),
};

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};

export const PATH_ZONE_ON_STORE = 'https://mui.com/store/items/zone-landing-page/';

export const PATH_MINIMAL_ON_STORE = 'https://mui.com/store/items/minimal-dashboard/';

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';
